import { actionCopyFr } from "./actionCopy";

export const authCopyFr = {
    backToWebsite: "Retour au site web",
    languageLabel: "Language / Sprache / Sprog / Langue",
    languageDescription:
        "Change the app language. Sprache der App ändern. Skift appsprog. Changer la langue de l'application.",
    chooseLanguage: "Choisir la langue",
    or: "OU",
    next: actionCopyFr.next,
    submit: actionCopyFr.submit,
    continue: actionCopyFr.continue,
    logout: "Se déconnecter",
    verifyingAuthentication: "Vérification de l'authentification...",
    signUpSignIn: "Inscription / Connexion",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    signUpWith: (name) => `S'inscrire avec ${name}`,
    joinStudy: (studyName) => `Rejoindre ${studyName}`,
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signInWithPasswordInstead: "Se connecter avec un mot de passe",
    contactMethodLabel: "Moyen de contact",
    patientRole: "Patient",
    forgotPassword: "Mot de passe oublié",
    confirmYourAccount: "Confirmez votre compte",
    choosePassword: "Choisir un mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    showPassword: "Afficher le mot de passe",
    passwordsDontMatch: "Les mots de passe ne correspondent pas",
    passwordsMatch: "Les mots de passe correspondent",
    passwordAllGood: "Parfait !",
    passwordRequirementMinLength: "Doit contenir au moins 8 caractères",
    passwordRequirementLowercase: "Doit contenir une lettre minuscule",
    passwordRequirementUppercase: "Doit contenir une lettre majuscule",
    passwordRequirementNumber: "Doit contenir un chiffre",
    passwordRequirementSpecial: "Doit contenir un caractère spécial",
    setYourPassword: "Définissez votre mot de passe",
    setPasswordDescription: "Créez un mot de passe sécurisé pour votre compte",
    settingPassword: "Définition du mot de passe...",
    smartAuthHint:
        "Saisissez l'adresse e-mail ou le numéro de téléphone auquel votre invitation Patient Watch a été envoyée.",
    usePhoneInstead: "Utiliser le téléphone",
    useEmailInstead: "Utiliser l'e-mail",
    phoneVerificationHint: "Nous enverrons un code de vérification sur votre téléphone.",
    phoneSignupHint:
        "Nous enverrons un code de vérification sur votre téléphone. Des frais de messagerie standard peuvent s'appliquer.",
    loggingIn: "Connexion...",
    sendingCode: "Envoi du code...",
    logIn: "Se connecter",
    sendCode: "Envoyer le code",
    sendVerificationCode: "Envoyer le code de vérification",
    sendingCodeEllipsis: "Envoi du code…",
    codeSent: "Code envoyé",
    codeSentToPhone: "Code envoyé sur votre téléphone",
    verificationCodeSent: "Code de vérification envoyé",
    emailFallbackCodeSent: "Nous n'avons pas pu envoyer de SMS, nous vous avons donc envoyé un code par e-mail.",
    checkFormAndTryAgain: "Veuillez vérifier le formulaire et réessayer.",
    somethingWentWrong: "Une erreur s'est produite. Veuillez réessayer.",
    newUser: "Nouvel utilisateur",
    invitationFound: "Invitation trouvée",
    accountFound: "Compte trouvé",
    accountFoundUseEmailSmsNotReady:
        "Compte trouvé. Connectez-vous avec votre e-mail. La connexion par SMS n'est pas encore configurée pour ce numéro sur votre compte.",
    smsLoginContactCareTeam:
        "La connexion par SMS n'est pas disponible pour ce numéro. Veuillez vous adresser à l'équipe qui vous a invité(e) pour obtenir de l'aide.",
    authMethodError: "Erreur de méthode d'authentification",
    smsLoginUnavailable:
        "La connexion par SMS n'est pas encore disponible pour ce numéro. Connectez-vous plutôt avec l'e-mail de votre compte.",
    email: "E-mail",
    emailTab: "E-mail",
    phoneTab: "Téléphone",
    emailPlaceholder: "p. ex. nom@entreprise.com",
    password: "Mot de passe",
    phone: "Numéro de téléphone",
    enterEmailAddress: "Saisissez votre adresse e-mail",
    enterPhoneNumber: "Saisissez votre numéro de téléphone",
    enterPhoneWithCountryCode: "Saisissez un numéro de téléphone avec l'indicatif du pays.",
    forgotPasswordEmailHint:
        "Saisissez l'adresse e-mail de votre compte. Nous vous enverrons un code de vérification pour réinitialiser votre mot de passe.",
    forgotPasswordPhoneHint:
        "Saisissez le numéro de téléphone de votre compte. Nous enverrons un code de vérification par SMS.",
    sending: "Envoi...",
    backToSignIn: "Retour à la connexion",
    backToForgotPassword: "Retour à « Mot de passe oublié »",
    backToConfirmAccount: "Retour à la confirmation du compte",
    backToSignup: "Retour à l'inscription",
    verifyYourAccount: "Vérifiez votre compte",
    verifyEmailCodeHint: "Saisissez le code de vérification envoyé à votre adresse e-mail.",
    verifySmsCodeHint: "Saisissez le code envoyé à votre numéro de téléphone.",
    verifying: "Vérification…",
    resendCode: "Renvoyer le code",
    didNotReceiveCode: "Vous n'avez pas reçu de code ?",
    resendConfirmationCode: "Renvoyer le code de confirmation",
    needHelpContact: "Besoin d'aide ? Contactez",
    consentTermsPrefix: "J'accepte les",
    termsOfUse: "Conditions d'utilisation",
    consentAnd: "et la",
    privacyPolicy: "Politique de confidentialité",
    selectHospitalLabel: "Dans quel hôpital êtes-vous suivi(e) pour ces soins ?",
    selectHospitalPlaceholder: "Sélectionnez votre hôpital",
    selectHospitalToContinue: "Veuillez sélectionner votre hôpital pour continuer.",
    ownOrganisationNameLabel: "Nom de l'organisation",
    ownOrganisationNamePlaceholder: "p. ex. Clinique orthopédique de la ville",
    ownOrganisationNameHint:
        "Cela crée votre organisation sur Patient Watch. Vous pourrez inviter vos collègues plus tard.",
    organisationNameTooShort: "Veuillez saisir un nom d'organisation d'au moins 3 caractères.",
    signupSessionExpired: "Votre session d'inscription a expiré. Revenez en arrière et demandez un nouveau code.",
    loadingSignup: "Chargement de l'inscription…",
    welcomeToPatientWatch: "Bienvenue sur Patient Watch",
    invitedByLine: (name) => `${name} vous a invité(e) à rejoindre Patient Watch.`,
    welcomeFirstTime: "Bienvenue - il semble que ce soit votre première visite.",
    choosePasswordDescription: "Choisissez un mot de passe pour terminer la configuration de votre compte.",
    alreadyHavePasswordSkip: "Passer - j'ai déjà un mot de passe",
    finishProfileSetup: "Terminons la configuration de votre profil.",
    continueToProfileSetup: "Continuer vers la configuration du profil",
    alreadySignedIn: "Déjà connecté(e)",
    alreadySignedInDescription:
        "Continuez vers l'application, ou déconnectez-vous si vous avez besoin d'un autre compte (par exemple pour ouvrir une invitation ou un lien d'inscription alors que vous êtes déjà connecté(e)).",
    continueToProfile: "Continuer",
    continueToApp: "Continuer",
    notLoggedInResetPassword: "Vous n'êtes pas connecté(e). Pour réinitialiser votre mot de passe, rendez-vous sur :",
    authenticationComplete: "Authentification réussie",
    authenticationCompleteDescription: "Vous êtes maintenant connecté(e), cliquez sur Suivant pour continuer.",
    authenticationFailed: "Échec de l'authentification",
    authenticationFailedDescription: "Lien invalide, veuillez réessayer.",
    noAccountFound: "Aucun compte trouvé",
    noAccountForContact: (contact) => `Aucun compte pour ${contact}`,
    noAccountForDetails: "Nous n'avons trouvé aucun compte correspondant à ces informations.",
    inviteOnlyPlatform:
        "Patient Watch est une plateforme sur invitation uniquement. Veuillez sélectionner votre rôle pour continuer :",
    iAmPatient: "Je suis un patient",
    iAmClinician: "Je suis un clinicien",
    wrongEmailGoBack: "Vous vous êtes trompé(e) d'adresse e-mail ?",
    goBackAndTryAgain: "Revenez en arrière et réessayez.",
    noAccountChoosePath:
        "Si vous êtes clinicien, vous pouvez commencer gratuitement dès maintenant. Si vous êtes patient, vous avez besoin d'une invitation.",
    noAccountPatientTitle: "Patients",
    noAccountPatientDescription:
        "Patient Watch est réservé aux patients invités. Demandez à votre cabinet de vous inviter, ou obtenez de l'aide si vous pensez avoir déjà reçu une invitation.",
    noAccountPatientCta: "J'ai besoin d'aide (patient)",
    noAccountClinicianTitle: "Cliniciens",
    noAccountClinicianDescription:
        "Invitez des patients, recueillez des scores de résultats et suivez leur évolution - gratuit pour commencer, sans carte bancaire. Ne passez à une formule supérieure que lorsque votre patientèle grandit.",
    noAccountClinicianCta: "Créer un compte gratuit",
    confirmAccountInviteTitle: "Vous êtes invité(e) à rejoindre Patient Watch",
    couldNotVerifyContact: "Nous n'avons pas pu vérifier vos coordonnées",
    invitedToJoin: "Vous êtes invité(e) à rejoindre Patient Watch",
    inviterInvitedYou: (name) => `${name} vous a invité(e).`,
    confirmPhoneInviteBody:
        "Confirmez votre numéro de téléphone ci-dessous. Nous vous enverrons un code de vérification par SMS afin que vous puissiez terminer la configuration de votre compte.",
    confirmEmailInviteBody:
        "Confirmez votre adresse e-mail ci-dessous. Nous vous enverrons un code de vérification afin que vous puissiez terminer la configuration de votre compte.",
    useInvitationContactDetails: "Utiliser les coordonnées de votre invitation",
    enterInvitationContactHint:
        "Saisissez l'adresse e-mail ou le numéro de téléphone auquel votre invitation Patient Watch a été envoyée.",
    enterConfirmationCode: "Saisissez le code de confirmation",
    processing: "Traitement en cours",
    verifyYourEmailTitle: "Vérifiez votre adresse e-mail",
    verifyEmailIcon: "Vérifiez votre adresse e-mail",
    emailConfirmed: "Adresse e-mail confirmée",
    emailConfirmedDescription: "Vous pouvez maintenant vous connecter.",
    verifyEmailWelcome: (firstName) =>
        `Bienvenue${firstName ? `, ${firstName}` : ""} ! Nous devons vérifier votre adresse e-mail.`,
    verifyEmailSendHint: "Nous enverrons un code de vérification à 6 chiffres à cette adresse e-mail.",
    sendingCodeButton: "Envoi du code...",
    sendVerificationCodeButton: "Envoyer le code de vérification",
    enterVerificationCode: "Saisissez le code de vérification",
    enterCodeSentTo: (email) => `Veuillez saisir le code envoyé à ${email}`,
    checkJunkFolder: "N'oubliez pas de vérifier votre dossier de courrier indésirable !",
    deleteAccount: "Supprimer le compte",
    deleteAccountReason: "Motif de la suppression du compte",
    troubleAccessingTitle: "Des difficultés pour accéder à Patient Watch ?",
    patientInviteMismatch: (email) =>
        `Si vous avez reçu une invitation, veuillez vérifier que l'adresse e-mail invitée est bien ${email}.`,
    patientContactProvider:
        "Si vous pensez que vous auriez dû recevoir une invitation, veuillez contacter votre prestataire de soins pour confirmer vos coordonnées.",
    contactSupportTeam: "Contacter notre équipe d'assistance",
    interestedInPwTitle: "Intéressé(e) par Patient Watch ?",
    interestedInPwBody1:
        "Patient Watch vous aide à suivre les résultats de vos patients et à rester en contact avec votre cabinet. La prise en main est rapide et simple - vous pouvez être opérationnel en quelques minutes.",
    interestedInPwBody2:
        "Commencez avec un compte gratuit - 5 nouveaux journaux par période de facturation, sans carte bancaire. Passez à l'offre Starter ou Pro lorsque vous avez besoin de plus de capacité. Les formules payantes incluent une garantie de remboursement de 30 jours si elles ne vous conviennent pas.",
    signupStarterPlan: "Voir les formules payantes",
    carePlanInjection: "Votre plan de soins comprend une injection.",
    carePlanInjectionTo: (where, substance, amount) => {
        if (where && substance && amount) return `Injection dans ${where} : ${substance} (${amount}).`;
        if (where && substance) return `Injection dans ${where} : ${substance}.`;
        if (where && amount) return `Injection dans ${where} (${amount}).`;
        if (where) return `Suivi après une injection dans ${where}.`;
        if (substance && amount) return `Injection : ${substance} (${amount}).`;
        if (substance) return `Injection : ${substance}.`;
        return "";
    },
    carePlanSurgery: "Votre plan de soins comprend une opération.",
    carePlanSurgeryArea: (area) => `Votre plan de soins comprend une opération (${area}).`,
    carePlanShockwave: "Votre plan de soins comprend un traitement par ondes de choc.",
    authErrorTitle: "Erreur d'authentification",
    almostThere: "Presque terminé !",
    preparingAccount: "Un instant, nous préparons votre compte...",
    verifyEmailCallBody: (email) =>
        `Veuillez saisir le code envoyé à ${email}.\n\nN'oubliez pas de vérifier vos courriers indésirables !`,
    verifyingPhone: "Vérification du numéro de téléphone",
    verifyingEmail: "Vérification de l'adresse e-mail",
    phoneVerified: "Téléphone vérifié",
    emailVerified: "Adresse e-mail vérifiée",
    verifyingPhoneWait: "Un instant, nous vérifions votre numéro de téléphone...",
    verifyingEmailWait: "Un instant, nous vérifions votre adresse e-mail...",
    phoneVerifiedSuccess: "Votre numéro de téléphone a bien été vérifié ! Configurons maintenant votre compte.",
    emailVerifiedSuccess: "Votre adresse e-mail a bien été vérifiée ! Configurons maintenant votre compte.",
    verifyPhoneError: "Veuillez réessayer de vérifier votre numéro de téléphone ou contacter support@patient-watch.com",
    verifyEmailError: "Veuillez réessayer de vérifier votre adresse e-mail ou contacter support@patient-watch.com",
    verificationError: "Erreur de vérification",
    tryAgain: "Réessayer",
    freemiumSignupTitle: "Créez votre compte gratuit",
    freemiumSignupDescription:
        "Invitez des patients, recueillez des scores de résultats et suivez leur rétablissement - prêt en quelques minutes, sans carte bancaire.",
    freemiumSignupBenefit1: "Invitez des patients et recueillez des scores de résultats immédiatement",
    freemiumSignupBenefit2: "Des rappels automatiques maintiennent l'engagement des patients entre les consultations",
    freemiumSignupBenefit3: "Suivez l'évolution dans le temps grâce à un tableau de bord clinicien clair",
    freemiumSignupCta: "Créer un compte gratuit",
    freemiumSignupSubmitting: "Création du compte…",
    freemiumSignupUpgradeHint: "Vous avez besoin d'un volume plus important ?",
    freemiumSignupSeePaidPlans: "Voir les autres formules",
    diaryInviteUnavailableTitle: "Cette invitation n'est pas disponible",
    diaryInviteUnavailableCallout: "Aucun journal n'a été démarré",
    diaryInviteUnavailableBody: "Il n'est pas possible d'ajouter un autre journal avec la formule actuelle.",
    diaryInviteUnavailableNextStep:
        "Veuillez contacter votre cabinet. Il pourra vous inviter à nouveau dès qu'il aura de la capacité.",
    diaryInviteOwnerUnresolvedBody:
        "Nous n'avons pas pu démarrer ce journal. Veuillez demander un nouveau lien d'invitation.",
    mfaEnrollTitle: "Configurer l'application d'authentification",
    mfaEnrollDescription: "Scannez ce code QR, puis saisissez le code à six chiffres de votre application.",
    mfaManualSetup: "Impossible de scanner le code QR ?",
    mfaQrCodeAlt: "Code QR de configuration de l'application d'authentification",
    mfaChallengeTitle: "Authentification à deux facteurs",
    mfaChallengeDescription: "Saisissez le code à six chiffres de votre application d'authentification.",
    mfaAuthenticatorCode: "Code d'authentification",
    mfaVerifyCode: "Vérifier le code",
    mfaVerifying: "Vérification…",
    mfaLoading: "Chargement…",
    mfaSettingsTitle: "Sécurité de l'application d'authentification",
    mfaSettingsDescription: "Votre application d'authentification est requise pour les accès privilégiés.",
    mfaFactorActive: "Application d'authentification active",
    mfaReplaceFactor: "Remplacer l'application d'authentification",
    mfaReplaceConfirm: "Supprimer cette application d'authentification et en configurer une nouvelle maintenant ?",
};
